export class StreetType {
  name!: string;
  id!: string;
  shortName!: string;
}
